import type { App } from 'vue'
import { discardChangesEventBus } from '../mixins/discardChangesMixin'

const discardChangesPlugin = {
  install(app: App): void {
    app.config.globalProperties.$sbDiscardChanges = {
      prevent(handler: () => void): void | Promise<void> {
        if (!discardChangesEventBus.all.has('discardChangesModalSync')) {
          return handler()
        }

        return discardChangesEventBus.emit('discardChangesPrevent', handler)
      },
    }
  },
}

export default discardChangesPlugin
